import app from "flarum/common/app";
function fallbackInternalPath(ref) {
  return "/" + ref.replace(/^\/+/, "");
}
function parseDiscussionRef(ref) {
  // Accept both the short form (d/123) and the canonical Flarum URL
  // (d/123-title or blog/123-title). Admin settings commonly contain the
  // latter, so it must not fall through to the plain-path fallback.
  const match = ref.replace(/^\/+/, "").match(/^(blog|d)\/(\d+)(?:-([^/?#]+))?\/?$/i);
  if (!match) return null;
  return {
    prefix: match[1].toLowerCase(),
    id: match[2],
    slug: match[3] || ""
  };
}
function delay(ms) {
  return new Promise(resolve => {
    setTimeout(resolve, ms);
  });
}
function getDiscussionSlug(discussion, id) {
  const slug = discussion.slug ? discussion.slug() : discussion.attribute("slug");
  return (slug || "").replace(new RegExp("^".concat(id, "-")), "");
}
function getLastReadNumber(discussion) {
  const lastRead = discussion.lastReadPostNumber ? discussion.lastReadPostNumber() : discussion.attribute("lastReadPostNumber");
  if (lastRead === null || typeof lastRead === "undefined" || lastRead === "") {
    return null;
  }
  const numeric = Number(lastRead);
  return Number.isFinite(numeric) ? numeric : null;
}

/**
 * ref lehet:
 *  - "blog/47069"
 *  - "blog/47069-bejegyzes-cime"
 *  - "d/12345"
 *  - "d/12345-tema-cime"
 *  - "https://valami.hu/..." (külső)
 */
export async function resolveTargetUrl(ref, _temp) {
  let _ref = _temp === void 0 ? {} : _temp,
    _ref$withNear = _ref.withNear,
    withNear = _ref$withNear === void 0 ? true : _ref$withNear;
  if (!ref || typeof ref !== "string") return "/";
  const trimmed = ref.trim();

  // Külső URL: hagyjuk békén
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  const parsed = parseDiscussionRef(trimmed);
  if (!parsed) return fallbackInternalPath(trimmed); // fallback: kezeld sima path-ként

  const prefix = parsed.prefix,
    id = parsed.id;
  const needsReadState = withNear && !!app.session.user;
  let discussion = await app.store.find("discussions", id);
  let safeSlug = getDiscussionSlug(discussion, id) || parsed.slug;
  let lastRead = getLastReadNumber(discussion);

  // Első page loadkor a store-ban néha még nincs slug/read-state.
  // Ilyenkor röviden újrapróbáljuk, hogy megérkezzen a teljes discussion rekord.
  for (let attempt = 0; attempt < 4; attempt++) {
    const missingSlug = !safeSlug;
    const missingReadState = needsReadState && lastRead === null;
    if (!missingSlug && !missingReadState) break;
    await delay(150);
    discussion = await app.store.find("discussions", id);
    safeSlug = getDiscussionSlug(discussion, id) || parsed.slug;
    lastRead = getLastReadNumber(discussion);
  }

  // Read-state suffix: ugyanaz az érték menjen az URL végére,
  // amit a felhasználó már elolvasott. Ha nincs ilyen, ne legyen suffix.
  const near = needsReadState && lastRead && lastRead > 0 ? lastRead : null;

  // URL összerakás
  // Fórum: /d/{id}-{slug}/{near}
  // Blog:  /blog/{id}-{slug}/{near}
  const base = fallbackInternalPath("".concat(prefix, "/").concat(id).concat(safeSlug ? "-" + safeSlug : ""));

  // Ha nem kérünk near-t vagy nincs read-state: base URL
  if (!near || !withNear) return base;
  return "".concat(base, "/").concat(near);
}
export { fallbackInternalPath };
flarum.reg.add('ubhu-ubuntu-release-countdown-widget', 'forum/utils/resolveTargetUrl', { fallbackInternalPath: fallbackInternalPath, });